"use strict";
var progress_directive_1 = require('./progressbar/progress.directive');
var bar_component_1 = require('./progressbar/bar.component');
var progressbar_component_1 = require('./progressbar/progressbar.component');
var progress_directive_2 = require('./progressbar/progress.directive');
exports.ProgressDirective = progress_directive_2.ProgressDirective;
var bar_component_2 = require('./progressbar/bar.component');
exports.BarComponent = bar_component_2.BarComponent;
var progressbar_component_2 = require('./progressbar/progressbar.component');
exports.ProgressbarComponent = progressbar_component_2.ProgressbarComponent;
exports.PROGRESSBAR_DIRECTIVES = [progress_directive_1.ProgressDirective, bar_component_1.BarComponent, progressbar_component_1.ProgressbarComponent];



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/progressbar.js
 ** module id = 821
 ** module chunks = 0
 **/